import * as React from "react";
import { useState } from "react";
import AsyncAction from "../AsyncAction";
import TextInput from "../commons/components/form/input/TextInput";
import InputState from "../commons/model/form/InputState";
import sfetch from "../commons/utils/super-fetch";
import ModalDelete from "../commons/components/modal/ModalDelete";
import EditAction from "../commons/components/action/EditAction";
import TextAction from "../commons/components/action/TextAction";

export interface SettingGoogleAnalytics4IntegrationProps {
  googleAnalytics4Id?: string;
  googleAnalytics4SettingUrl: string;
}

export default function SettingGoogleAnalyticsIntegration({
  googleAnalytics4Id,
  googleAnalytics4SettingUrl,
}: {
  googleAnalytics4Id?: string;
  googleAnalytics4SettingUrl: string;
}) {
  const [inputStateGA4, setInputStateGA4] = useState<InputState>();
  const [editModeGA4, setEditModeGA4] = useState<boolean>(!googleAnalytics4Id);
  const [deleteModeGA4, setDeleteModeGA4] = useState<boolean>(null);

  return (
    <div className="google-analytics-settings setting-description full-col">
      <div className="setting-title">
        {i18n["Page.Settings.Customisation.GoogleAnalytics.Title"]}
      </div>
      <div>{i18n["Page.Settings.Customisation.GoogleAnalytics.Description"]}</div>
      {googleAnalytics4SettingUrl && (
        <div className="space-top horizontal-block">
          <div className="bolder">
            {i18n["Page.Settings.Customisation.GoogleAnalytics4.Id.Label"]}
          </div>
          {editModeGA4 ? (
            <>
              <div className="react-form inline merge-columns">
                <TextInput
                  name="gaID"
                  initialValue={googleAnalytics4Id}
                  placeholder="G-XXXXXXX"
                  onChange={(inStateGA4) => setInputStateGA4(inStateGA4)}
                />
              </div>
              <div className="v-flex">
                <AsyncAction
                  buttonLabel={i18n["Global.Save"]}
                  promise={() => setGoogleAnalytics4Id()}
                />
              </div>
            </>
          ) : (
            <div className="h-flex with-margins merge-columns">
              <div>{googleAnalytics4Id}</div>
              <div className="h-flex with-separator">
                <EditAction onClick={() => setEditModeGA4(true)} />
                <TextAction
                  icon={<i className="ic_broken-link" />}
                  label={i18n["Global.Disconnect"]}
                  additionalClass="danger"
                  onClick={() => setDeleteModeGA4(true)}
                />
              </div>
            </div>
          )}
        </div>
      )}

      {googleAnalytics4SettingUrl && deleteModeGA4 && (
        <ModalDelete
          title={i18n["Page.Settings.Customisation.GoogleAnalytics4.Disconnect.Title"]}
          action={() => deleteGoogleAnalytics4Id()}
          cancel={() => setDeleteModeGA4(false)}
        >
          {i18n["Page.Settings.Customisation.GoogleAnalytics4.Disconnect.Content"]}
        </ModalDelete>
      )}
    </div>
  );

  function setGoogleAnalytics4Id() {
    return sfetch(googleAnalytics4SettingUrl, {
      method: "PUT",
      body: inputStateGA4.value,
    })
      .then(() => document.location.reload())
      .catch((res) => {
        if (res.status === 400) {
          inputStateGA4.status.setError(
            i18n["Page.Settings.Customisation.GoogleAnalytics4.Id.Error.Format"]
          );
        } else if (res.status === 500) {
          inputStateGA4.status.setError(
            i18n["Page.Settings.Customisation.GoogleAnalytics4.Id.Error.Message"]
          );
        }
        throw res;
      });
  }

  function deleteGoogleAnalytics4Id() {
    return sfetch(googleAnalytics4SettingUrl, {
      method: "DELETE",
    }).then(() => document.location.reload());
  }
}
